var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"feed"},[(_vm.feedType==='rounds')?_c('RoundFeed',{on:{"openComments":_vm.openComments}}):(_vm.feedType==='videos')?_c('ScrollFeed',{on:{"openComments":_vm.openComments}}):(_vm.feedType==='channels')?_c('ScrollFeed'):_c('StreamsFeed'),_c('Modal',{ref:"comments"},[_c('Comments',{attrs:{"round":_vm.commentsRound}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }